<section class="content-header">
  <a (click)="goBack()" class="previous cur">&laquo; Retour au listes des commandes</a>
  <div class="container-fluid">
    <div class="row mb-2">
      <h2>Ajouter une commande</h2>
    </div>
  </div>
</section>
<section class="content">
  <div class="container-fluid">

    <div class="card-body">
      <div class="row">


        <form name="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="id">Id commande </label>
                <input type="text" id='id' class="form-control" formControlName="id"
                       [ngClass]="{ 'is-invalid': submitted && f.id.errors }"/>
                <div *ngIf="submitted && f.id.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.id.errors.required">*Id requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="objet">Objet </label>
                <input type="text" id='objet' class="form-control" formControlName="objet"
                       [ngClass]="{ 'is-invalid': submitted && f.objet.errors }"/>
                <div *ngIf="submitted && f.objet.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.objet.errors.required">*Objet requis</div>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="prix">Prix </label>
                <input type="text" id='prix' class="form-control" formControlName="prix"
                       [ngClass]="{ 'is-invalid': submitted && f.prix.errors }"/>
                <div *ngIf="submitted && f.prix.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.prix.errors.required">*Prix requis</div>
                </div>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Agence</label>
                <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                        formControlName="agence" [ngClass]="{ 'is-invalid': submitted && f.agence.errors }">>
                  <option value="" disabled selected>Sélectionnez une agence</option>
                  <option *ngFor="let agence of agences" [value]=agence.customerId>{{agence.name}}</option>
                </select>
                <div *ngIf="submitted && f.agence.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.agence.errors.required">*Agence requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Annonceur</label>
                <select (change)="annonceur($event)" class="form-control select2 select2-hidden-accessible"
                        style="width: 100%;"
                        formControlName="annonceur">
                  <option value="" disabled selected>Sélectionnez un annonceur</option>
                  <option *ngFor="let annonceur of annonceurs" [value]=annonceur.siren>{{annonceur.name}}</option>

                </select>
                <div *ngIf="submitted && f.annonceur.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.annonceur.errors.required">*Annonceur requis</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Commercial</label>
                <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                        formControlName="commercial" [ngClass]="{ 'is-invalid': submitted && f.commercial.errors }">
                  <option value="" disabled selected>choisissez un commercial</option>
                  <option *ngFor="let commercial of commercials" [value]=commercial.id>{{commercial.name}}</option>
                </select>
                <div *ngIf="submitted && f.commercial.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.commercial.errors.required">*Commercial requis</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Acheteur</label>
                <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                        formControlName="acheteur" [ngClass]="{ 'is-invalid': submitted && f.acheteur.errors }">
                  <option value="" disabled selected>Choisissez un acheteur</option>
                  <option *ngFor="let buyer of buyers" [value]=buyer.id>{{buyer.name}}</option>
                </select>
                <div *ngIf="submitted && f.acheteur.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.acheteur.errors.required">*Acheteur requis</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class=" col-md-4 ">
              <div class="form-group">
                <label for='dateCreation'>Date création </label>
                <div class="input-group-prepend">
                  <mat-form-field>
                    <input matInput formControlName="dateCreation" [matDatepicker]="dateCreationPicker" id="dateCreation">
                    <mat-datepicker-toggle matSuffix [for]="dateCreationPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateCreationPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-md-4 ">
              <div class="form-group">
                <label for='DateSign'>Date signature </label>
                <div class="input-group-prepend">
                  <mat-form-field>
                    <input matInput formControlName="DateSign" [matDatepicker]="dateSignPicker" id="DateSign"
                      [ngClass]="{ 'is-invalid': submitted && f.DateSign.errors }">
                    <mat-datepicker-toggle matSuffix [for]="dateSignPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateSignPicker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="submitted && f.DateSign.errors" class="invalid-feedback">
                    <div class="err" *ngIf="f.DateSign.errors.required">*Date de début requis</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for='DateEx'>Date exécution </label>
                <div class="input-group-prepend">
                  <mat-form-field>
                    <input matInput formControlName="DateEx" [matDatepicker]="dateExPicker" id="DateEx"
                      [ngClass]="{ 'is-invalid': submitted && f.DateEx.errors }">
                    <mat-datepicker-toggle matSuffix [for]="dateExPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateExPicker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="submitted && f.DateEx.errors" class="invalid-feedback">
                    <div class="err" *ngIf="f.DateEx.errors.required">*Date de début requis</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br/>

          <div class="container-fluid">
            <div class="row mb-2">
              <h3>Ajouter un spot</h3>
            </div>
          </div>
          <br/>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="idSpot">Id spot </label>
                <input type="text" id='idSpot' class="form-control" formControlName="idSpot"
                       [ngClass]="{ 'is-invalid': submitted && f.idSpot.errors }"/>
                <div *ngIf="submitted && f.idSpot.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.idSpot.errors.required">*Id spot requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="idPub">Id pub </label>
                <input type="text" id='idPub' class="form-control" formControlName="idPub"
                       [ngClass]="{ 'is-invalid': submitted && f.idPub.errors }"/>
                <div *ngIf="submitted && f.idPub.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.idPub.errors.required">*Id pub requis</div>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="duration">Durée </label>
                <input type="text" id='duration' class="form-control" formControlName="duration"
                       [ngClass]="{ 'is-invalid': submitted && f.duration.errors }"/>
                <div *ngIf="submitted && f.duration.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.duration.errors.required">*Prix requis</div>
                </div>
              </div>
            </div>

          </div>


          <br/>

          <div class="container-fluid">
            <div class="row mb-2">
              <h3>Ajouter un item</h3>
            </div>
          </div>
          <br/>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="idItem">Id item </label>
                <input type="text" id='idItem' class="form-control" formControlName="idItem"
                       [ngClass]="{ 'is-invalid': submitted && f.idItem.errors }"/>
                <div *ngIf="submitted && f.idItem.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.idItem.errors.required">*Id item requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="nomItem">Nom item </label>
                <input type="text" id='nomItem' class="form-control" formControlName="nomItem"
                       [ngClass]="{ 'is-invalid': submitted && f.nomItem.errors }"/>
                <div *ngIf="submitted && f.nomItem.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.nomItem.errors.required">*Nom item requis</div>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="typeItem">Type item </label>
                <input type="text" id='typeItem' class="form-control" formControlName="typeItem"
                       [ngClass]="{ 'is-invalid': submitted && f.typeItem.errors }"/>
                <div *ngIf="submitted && f.typeItem.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.typeItem.errors.required">*Type item requis</div>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Canal</label>
                <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                        formControlName="chanel" [ngClass]="{ 'is-invalid': submitted && f.chanel.errors }">
                  <option value="" disabled selected>Sélectionnez une chaîne</option>
                  <option *ngFor="let chaine of channels" [value]=chaine.id>{{chaine.name}}</option>
                </select>
                <div *ngIf="submitted && f.chanel.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.chanel.errors.required">*Canal requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-4 ">
              <div class="form-group">
                <label for='startDate'>Date de début </label>
                <div class="input-group-prepend">
                  <mat-form-field>
                    <input matInput formControlName="startDate" [matDatepicker]="startDatePicker" id="startDate"
                      [ngClass]="{ 'is-invalid': submitted && f.startDate.errors }">
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="submitted && f.startDate.errors" class="invalid-feedback">
                    <div class="err" *ngIf="f.startDate.errors.required">*Date de début requis</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for='endDate'>Date de fin </label>
                <div class="input-group-prepend">
                <mat-form-field>
                  <input matInput formControlName="endDate" [matDatepicker]="endDatePicker" id="endDate"
                    [ngClass]="{ 'is-invalid': submitted && f.endDate.errors }">
                  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
                  <div *ngIf="submitted && f.endDate.errors" class="invalid-feedback">
                    <div class="err" *ngIf="f.endDate.errors.required">*Date de fin requis</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="tarif">Tarif </label>
                <input type="text" id='tarif' class="form-control" formControlName="tarif"
                       [ngClass]="{ 'is-invalid': submitted && f.tarif.errors }"/>
                <div *ngIf="submitted && f.tarif.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.tarif.errors.required">*Tarif requis</div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="volume">Volume </label>
                <input type="text" id='volume' class="form-control" formControlName="volume"
                       [ngClass]="{ 'is-invalid': submitted && f.volume.errors }"/>
                <div *ngIf="submitted && f.volume.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.volume.errors.required">*Volume requis</div>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="typeItem">Statut </label>
                <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                        formControlName="status" [ngClass]="{ 'is-invalid': submitted && f.status.errors }">
                  <option value="" disabled selected>Sélectionnez statut</option>
                  <option value="done">Effectué</option>
                  <option value="notDone">À faire</option>
                </select>
                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                  <div class="err" *ngIf="f.status.errors.required">*Statut requis</div>
                </div>
              </div>
            </div>

          </div>


          <br/>

          <div class="d-flex">
            <div class="mr-auto p-2"></div>


            <div class="p-2">
              <button class="btn btn-primary pull-right">Ajouter</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</section>

